import { HELM_POLYMER_TYPE } from '../utils/const';
import { ALPHABET } from '../utils/macromolecule';
export function getUnusedColName(df, colName) {
    if (!df)
        return colName;
    return df.columns.getUnusedName(colName);
}
export function getMolColName(df, seqColName) {
    return getUnusedColName(df, `molfile(${seqColName})`);
}
export function alphabetToPolymerType(alphabet) {
    // determine the polymer type according to HELM specifications
    let resPolymerType;
    // todo: an exception from dart comes before this check if the alphabet is UN
    if (alphabet === ALPHABET.PT || alphabet === ALPHABET.UN)
        resPolymerType = HELM_POLYMER_TYPE.PEPTIDE;
    else if (alphabet === ALPHABET.RNA || alphabet === ALPHABET.DNA)
        resPolymerType = HELM_POLYMER_TYPE.RNA;
    else
        throw new Error(`Unexpected alphabet '${alphabet}'.`);
    return resPolymerType;
}
/** @deprecated Use DG.Color.hexToPercentRgb */
export function hexToPercentRgb(hex) {
    const result = hex.length === 7 ? /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex) :
        /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [
        parseInt(result[1], 16) / 256,
        parseInt(result[2], 16) / 256,
        parseInt(result[3], 16) / 256,
        result.length > 4 ? parseInt(result[4], 16) / 256 : 0.3
    ] : null;
}
//# sourceMappingURL=utils.js.map